import script from "./AIReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AIReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./AIReviewModal.vue?vue&type=style&index=0&id=30703e41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30703e41"]])

export default __exports__